var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLiveRoulette = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9372_70115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.85187 15.8681C2.01822 16.5345 2.61455 17 3.30119 17H13.6991C14.3857 17 14.9821 16.5345 15.1484 15.8681L15.6126 14.0117H1.3877L1.85187 15.8681Z",
    fill: "#CCD6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.0273H17V13.0156H0V10.0273Z",
    fill: "#CCD6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51562 5.97656C5.16491 5.97656 5.71851 5.56013 5.9241 4.98047H7.61397L7.16756 9.03125H9.83244L9.38606 4.98047H11.0759C11.2815 5.56013 11.8351 5.97656 12.4844 5.97656C13.3083 5.97656 13.9785 5.30629 13.9785 4.48242C13.9785 3.65855 13.3083 2.98828 12.4844 2.98828C11.8351 2.98828 11.2815 3.40471 11.0759 3.98438H9.27629L9.15008 2.83923C9.64919 2.59705 9.99414 2.08516 9.99414 1.49414C9.99414 0.670271 9.32387 0 8.5 0C7.67613 0 7.00586 0.670271 7.00586 1.49414C7.00586 2.08516 7.35081 2.59705 7.84992 2.83923L7.72371 3.98438H5.9241C5.71851 3.40471 5.16491 2.98828 4.51562 2.98828C3.69176 2.98828 3.02148 3.65855 3.02148 4.48242C3.02148 5.30629 3.69176 5.97656 4.51562 5.97656Z",
    fill: "#CCD6F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9372_70115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLiveRoulette);
export default ForwardRef;